import PayAccessChart from './PayAccessChart'

export default PayAccessChart
